import axios from "axios";
import types from "./store/actionTypes";
import config from "./config/config";
import { Auth } from 'aws-amplify';

import  AuthService  from './utils/authSerivce'
import { getCarrierByDomain } from "./domain";

const auth = new AuthService


const http = axios.create({
  baseURL: '/',
  // baseURL: 'https://7ty7z1y2j3.execute-api.ap-northeast-1.amazonaws.com/sqa/',
  // baseURL: 'https://uzl2nastx5.execute-api.ap-northeast-1.amazonaws.com/uat/',
  responseType: "json",
});

async function signIn(username, password) {
  return await Auth.signIn(username, password)
}

async function signOut() {
  return await Auth.signOut()
}

const API = {};
let headers = {
  Accept: "application/json",
  // "x-api-key": 'YEuqiwRh3Ku9XJBOPHXH8WVWwT2qaTU8IegxDcu9',
  "x-api-key": config?.xApiKey,
  "Asurion-client": getCarrierByDomain(), //(window.client || "").toLowerCase(),
  "Content-Type": "application/json",
  "Asurion-channel": "agent",
  "Asurion-region": "APAC-SEA",
  "Asurion-lineofbusiness": "Mobility",
  pragma: "no-cache",
  "X-Requested-With": "XMLHttpRequest",
  Expires: "-1",
  "If-Modified-Since": "Thu, 13 Feb 1985 13:40:01 GMT",
  "Cache-Control": "no-cache,no-store,must-revalidate,max-age=-1,private",
  "Asurion-application": "dpp",
};

API[types.GENERATE_TOKEN] = (url, payload, headers) =>
  http.post(url, payload, headers);

API[types.POST_LOGGER] = (payload, idToken, userName) =>
  http.post(
    "api/logger",
    { LoggerRequest: payload },
    { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } }
  );

API[types.GET_STARHUB_REPORT_COUNT] = (payload, idToken, userName) =>
  http.post("api/getreportcount", { GetReportCoutRequest : payload }, { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } })

API[types.GET_STARHUB_REPORT_COUNT_DETAILS] = (payload, idToken, userName) =>
  http.post("api/getreportcountdetails", { GetReportCountDetailsRequest : payload }, { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } })

API[types.GET_STARHUB_REPORT_DETAILS] = (payload, idToken, userName) =>
  http.post("api/getreportdetails", { GetReportDetailsRequest : payload }, { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } })

  API[types.VALIDATE_EMAIL_PASSWORD] = async (email, password) => {
    return await auth.signIn(email, password)
  }

  API[types.CHANGE_PASSWORD] = async (password) => {
    return await auth.changePassword(password)
  }

  API[types.VERIFY_OTP_REQUEST] = async (otp) => {
    return await auth.verifyOtp(otp)
  }

  API[types.SIGNOUT_REQUEST] = () => {
    return auth.signOut()
  }

  API[types.GET_CHART_COUNT_DATA] = (payload, userName) =>
  http.get("api/gettotalreportscount", {
    headers: { ...headers, Authorization: payload?.idToken, 'Asurion-enduser': userName || 'oneops' },
  });
  
  API[types.GET_SLA_REPORTS_DETAILS] = (payload, userName) =>
  http.get(`api/getsladetails?reportMonth=${payload?.month}`, {
    headers: { ...headers, Authorization: payload?.idToken, 'Asurion-enduser': userName || 'oneops' },
  });

  API[types.SGP_DOWNLOAD_REPORT] = (payload, idToken, userName) =>
    http.post("api/downloadreports", { DownloadReportRequest : payload }, { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } })
  
  API[types.GET_USER_DETAILS] = (payload) =>
    http.post("api/userdetails", payload, { headers: { ...headers } })

  API[types.GET_CELCOM_FIANANCE_DETAILS] = (payload, idToken, userName) =>
    http.post("api/getfrireport", {GetVolumeClosingRequest: payload}, { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } })

  API[types.GET_CELCOM_CUSTOMER_VALUE_MGMT_DETAILS] = (payload, idToken, userName) =>
    http.post("api/custvaluemanagement", {GetCustomerValueManagementRequest: {}}, { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } })

  API[types.UPLOAD_FIANANCE_REPORT] = (payload, idToken, userName) =>
    http.post("api/addfinancereport", { AddFinanceReportRequest: payload }, { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } })

  API[types.GET_FIANANCE_REPORTS_DETAILS] = (idToken, userName) =>
    http.get(`api/getallfinancereport`, {
      headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' },
    });

  API[types.SIGNOUT_REQUEST] = () => {
    return auth.signOut()
  }

  API[types.ADD_REBATE] = (payload, idToken, userName) =>
    http.post("api/addrebate", 
      { AddRebateRequest: payload }, 
      { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } 
  })

  API[types.GET_MONTHWISE_REBATE] = (payload, idToken, userName) =>
    http.post("api/getmonthwiserebate", 
      { GetRebateRequest: payload }, 
      { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' } 
  })

  API[types.GET_SALES_BUSINESS_REPORT] = (payload, idToken, userName) =>
    http.post("api/salesbusinessreport", 
      { SalesBusinessReportRequest: payload }, 
      { headers: { ...headers, Authorization: idToken, 'Asurion-enduser': userName || 'oneops' }

  })

  
export default API;
